import * as React from 'react';

export const InstaSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19.5}
      height={19.5}
      fill='none'
      viewBox="0 0 0.394 0.394"
    >
      <path
      d="M0.197 0.131a0.066 0.066 0 1 0 0 0.131 0.066 0.066 0 0 0 0 -0.131"
      fill="#77af5c"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.118 0A0.118 0.118 0 0 0 0 0.118v0.158A0.118 0.118 0 0 0 0.118 0.394h0.158a0.118 0.118 0 0 0 0.118 -0.118v-0.158A0.118 0.118 0 0 0 0.276 0zM0.105 0.197a0.092 0.092 0 1 1 0.184 0 0.092 0.092 0 0 1 -0.184 0M0.289 0.105h0.026V0.079h-0.026z"
        fill="#77af5c"
      />
    </svg>
  );
};
